<template>
  <div v-if="discount" class="line">
    <!-- DISCOUNT -->
    <div class="name col-xs-12 col-md-4" name="discountLabel">
      <label class="text">Discount</label>
    </div>
    <div class="pull-left text-center">&nbsp;&nbsp;</div>
    <div class="col-xs-12 col-md-2">
      <ed-input
        @change="() => computeDiscountValue(model)"
        v-model.number="model.discountPercent"
        symbol="%"
        amount
        autoselect
        name="discount_percent"
        ref="discountPercentage"
      ></ed-input>
    </div>
    <div class="pull-left text-center">&nbsp;&nbsp;&nbsp;&nbsp;</div>
    <div class="col-xs-12 col-md-2">
      <ed-input
        @change="() => resetDiscount(model)"
        v-model="model.discountAmount"
        amount
        type="money"
        autoselect
        negative
        :currency="ctx.currency"
        name='discount_amount'
        ref="discountValue"
      ></ed-input>
    </div>
  </div>
  <div v-else class="line">
    <hr class="clear separator col-md-8" />
    <!-- USE -->
    <div class="name col-md-4">
      <check v-if="typeof model.isChecked !== 'undefined'"
        :option-label="model.name"
        :option-status="model.isChecked"
        @change-status="() => useTax(model)"
        @input="taxInput"
        :name="model.name"
        v-bind:id="ctx.getTaxId(model.name)"
      />
      <label v-else>{{ model.name }}</label>
    </div>
    <div class="pull-left text-center">&nbsp;&nbsp;</div>

    <!--  PERCENT -->
    <div class="col-xs-12 col-md-2">
      <ed-input
        @change="() => computeTaxValue(model)"
        v-model.number="model.percentage"
        symbol="%"
        amount
        autoselect
        :disabled="!model.isChecked && !hasTotal"
        :class="{ 'not-used': !model.isChecked && !hasTotal, 'loading list': loading }"
        :name="ctx.getNamePercent(model.name)"
        ref="taxPercentages"
        :supplementalPrecision="6"
      ></ed-input>
    </div>
    <div class="pull-left text-center">&nbsp;&nbsp;&nbsp;&nbsp;</div>

    <!-- VALUE -->
    <div class="col-xs-2" :class="{ 'col-md-2': hasTotal, 'col-md-2': !hasTotal }">
      <ed-input
        @change="() => resetTax(model)"
        v-model="model.value"
        amount
        type="money"
        autoselect
        :currency="ctx.currency"
        :disabled="!model.isChecked && !hasTotal"
        :class="{ 'not-used': !model.isChecked && !hasTotal }"
        :name="ctx.getNameAmount(model.name)"
        ref="taxValues"
        :supplementalPrecision="6"
      ></ed-input>
    </div>

    <!-- TOTAL -->
    <a v-if="hasTotal" class="col-xs-12 col-md-2 text-right totals"
      href="#"
      @click.prevent="details(model)"
      :name="ctx.getNameLink(model.name)"
    >
      <v-money class="solid" :currency="ctx.currency" :supplementalPrecision="6">{{ model.totalTaxes }}</v-money>
    </a>
  </div>
</template>

<script>

import Check from '@/core/components/edCheckbox/checkbox'

export default {
  components: {
    Check
  },

  props: {
    model: Object,
    details: Function,
    compute: Function,
    discount: Boolean,
    context: Object,
    endpoint: String
  },

  computed: {
    hasTotal() {
      return typeof this.model.totalTaxes !== 'undefined' && this.details
    }
  },

  data() {
    return {
      ctx: this.context || this.$parent,
      loading: false
    }
  },

  methods: {
    taxInput(val) {
      if (!val) {
        this.model.isChecked = false
      } else {
        this.model.isChecked = val
      }
    },

    useTax(tax) {
      tax.value = ''
      this.computeTaxValue(tax)
    },

    resetTax(tax) {
      let taxComp = this.$refs.taxPercentages
      tax.percentage = null
      this.loading = true
      this.compute().then(() => {
        taxComp.amountValue = ''
        this.loading = false
      })
    },

    resetDiscount(model) {
      let discountComp = this.$refs.discountPercentage
      model.discountPercent = null
      this.compute().then(() => {
        discountComp.amountValue = ''
      })
    },

    computeTaxValue(tax) {
      let taxComp = this.$refs.taxValues
      let taxCompPercent = this.$refs.taxPercentages

      if (!tax.percentage) {
        tax.value = ''
        tax.percentage = null
      } else {
        tax.value = 0
      }

      this.resetComps(tax, taxComp, taxCompPercent)
    },

    computeDiscountValue(model) {
      let discountComp = this.$refs.discountValue
      let discountCompPercent = this.$refs.discountPercentage

      if (!model.discountPercent) {
        model.discountAmount = ''
        model.discountPercent = null
      }

      this.resetComps({ percentage: model.discountPercent }, discountComp, discountCompPercent)
    },

    resetComps(comp, value, percent) {
      value.$el.setAttribute('endpoint', this.ctx.computeItemTotalEndpoint)

      this.compute().then(() => {
        value.$el.removeAttribute('endpoint')
        value.formatMoney()
        if (!comp.percentage) {
          percent.amountValue = ''
        }
      })
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.line {
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  padding-top: 8px;
  padding-bottom: 8px;

  @include theme {
    //border-top: 1px solid v(background-light);
    //border-bottom: 1px solid v(background-light);
  }
  + .line {
    border-top: none;
    margin-top: -5px;
  }
  margin-bottom: 5px;

  >>> .form-group {
    margin-bottom: 0;
  }

  .totals {
    line-height: 2em;
  }
  .name {
    line-height: 2em;
    padding-left: 2px;
    label {
      margin-bottom: 0;
    }
  }
}

.separator {
  margin: -8px 0 5px;
  padding: 0 2px;
}

.row >>> {

  label.text, .dawn-checkbox {
    // font-weight: $font-weight-normal;
    line-height: 2em;
  }
  .form-check-label .text {
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
    margin-left: 5px;
  }
  .form-group.not-used {
    .form-control,
    .symbol-holder {
      opacity: 0.5;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/components/taxLine.vue